import { css } from 'emotion'
import baseColorRepository, {
  name,
} from '@/middlewares/styles/baseColorRepository'

const wrapper = color => {
  return css`
    background: ${color};
    color: #ffffff;
    height: 100%;
  `
}

const list = css`
  padding: 0;
  font-size: 16px;
  list-style: none;
`

const item = (base1, base1Selected) => {
  return isSelected => {
    const background = isSelected ? base1Selected : base1
    return css`
      background: ${background};
      color: #ffffff;
      cursor: pointer;
      padding: 12px 16px;
      transition: background 0.2s ease-in-out;
      :hover {
        background: ${base1Selected};
      }
    `
  }
}

const titleWrapper = css`
  display: flex;
  align-items: center;
`

const iconWrapper = css`
  margin-right: 10px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-content: center;
`

const styles = color => {
  const styleObject = baseColorRepository(color)
  return {
    wrapper: wrapper(styleObject[name.base1]),
    item: item(styleObject[name.base1], styleObject[name.base1Selected]),
    list,
    titleWrapper,
    iconWrapper,
  }
}

export default styles
